import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
var StandingBar = /*#__PURE__*/function (_Component) {
  function StandingBar() {
    var _this;
    _classCallCheck(this, StandingBar);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, StandingBar, [].concat(args));
    /* Render methods */
    _defineProperty(_this, "renderData", function () {
      var data = _this.props.data;
      var total = 0;
      if (data != null && data.length > 0) {
        data.forEach(function (entry) {
          total += entry.amount;
        });
      }
      return data.map(function (entry, index) {
        var height = 0;
        if (entry.amount != null && entry.amount > 0) {
          var percentage = entry.amount / total * 100;
          height = Math.floor(percentage) * _this.props.heightUnit;
        }
        if (height <= _this.props.minimumHeight) {
          height = _this.props.minimumHeight;
        }
        return /*#__PURE__*/React.createElement("div", {
          key: 'graph-standingbar-bar' + index,
          className: "bar"
        }, _this.props.showAmount ? /*#__PURE__*/React.createElement("span", {
          className: "amount"
        }, entry.amount) : null, /*#__PURE__*/React.createElement("div", {
          className: "color",
          style: {
            backgroundColor: entry.color,
            height: height
          }
        }));
      });
    });
    return _this;
  }
  _inherits(StandingBar, _Component);
  return _createClass(StandingBar, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "graph standing-bar"
      }, /*#__PURE__*/React.createElement("div", {
        className: "bar-container"
      }, this.renderData()));
    }
  }]);
}(Component);
/* Class setup */
_defineProperty(StandingBar, "defaultProps", {
  heightUnit: 2,
  minimumHeight: 5,
  showAmount: true
});
export default StandingBar;